<template>
  <v-container class="mt-3 pa-0">
    <v-card color="primary">
      <v-toolbar color="primary" flat>
        <v-tooltip bottom>
          <v-toolbar-side-icon
            @click="getHistory(searchParams)"
            slot="activator"
            icon
          >
            <v-icon>refresh</v-icon>
          </v-toolbar-side-icon>
          <span>Refresh Pickup/Delivery list</span>
        </v-tooltip>
        <v-toolbar-title class="hidden-xs-only">
          <h3>Pickup/Delivery ({{ history.totalItems }})</h3>
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :items="history.docs"
        :headers="headers"
        :pagination.sync="pagination"
        :total-items="history.totalItems"
        class="primary"
        ref="dataTable"
        item-key="_id"
      >
        <template v-slot:items="props">
          <tr
            :class="
              props.item.packages === 'Unknown'
                ? 'pl-1 primary lighten-1'
                : 'pl-1'
            "
          >
            <td>{{ props.item.company ? props.item.company : "--" }}</td>
            <td>{{ props.item.type ? props.item.type : "--" }}</td>
            <td>
              <v-edit-dialog
                class="edit-dialog"
                large
                :return-value.sync="props.item.packages"
                @save="save(props.item)"
                color="secondary"
              >
                {{ props.item.packages }}
                <template v-slot:input>
                  <v-text-field
                    color="secondary"
                    v-model="props.item.packages"
                    label="Update Number"
                    single-line
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td>{{ props.item.date ? props.item.date : "" }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";

export default {
  data() {
    return {
      search: "",
      type: "pd",
      pagination: {
        rowsPerPage: 10,
        sortBy: "date",
        descending: true,
        page: 1
      },
      headers: [
        {
          text: "Company/Carrier",
          value: "company"
        },
        {
          text: "Pickup/Delivery",
          value: "type"
        },
        {
          text: "# of Packages/Pallets",
          value: "packages"
        },
        {
          text: "Date",
          value: "date"
        }
      ]
    };
  },

  watch: {
    pagination: {
      handler() {
        this.getHistory(this.searchParams);
      },
      deep: true
    }
  },
  mounted() {
    this.getHistory(this.searchParams);
  },

  mixins: [LoginCheck],

  computed: {
    ...mapGetters({
      history: "signin/getHistory"
    }),
    searchParams() {
      return {
        ...this.pagination,
        type: this.type
      };
    }
  },
  methods: {
    ...mapActions({
      getHistory: "signin/getHistory",
      update: "signin/update",
      setSnackbar: "app/setSnackbar"
    }),
    save(item) {
      this.update({ id: item._id, body: item });
      this.setSnackbar({
        text: "Value has been updated!",
        color: "green"
      });
    }
  }
};
</script>

<style>
.theme--dark.v-small-dialog__content {
  background: #333c42 !important;
}

.v-small-dialog__actions > .primary--text {
  color: #f04e23 !important;
}
</style>
